export default class LabelsModel {
  constructor() {
    this['Code'] = '';

    this['Group'] = '';

    this['IsSpecial'] = false;

    this['Name'] = '';
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Code')) {
      this['Code'] = dataSource['Code'] ? dataSource['Code'] : this['Code'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Group')) {
      this['Group'] = dataSource['Group'] ? dataSource['Group'] : this['Group'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'IsSpecial')) {
      this['IsSpecial'] = dataSource['IsSpecial'] ? dataSource['IsSpecial'] : this['IsSpecial'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Name')) {
      this['Name'] = dataSource['Name'] ? dataSource['Name'] : this['Name'];
    }

    return this;
  }
}
